var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "span",
                [_vm._v("Заголовок ("), _c("TranslationIcon"), _vm._v(")")],
                1
              ),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.title,
                  "error-messages": _vm.errorMessages.title,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "title")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "span",
                [_vm._v("Подзаголовок ("), _c("TranslationIcon"), _vm._v(")")],
                1
              ),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.subTitle,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "subTitle")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "span",
                [
                  _vm._v("Заголовок кнопки ("),
                  _c("TranslationIcon"),
                  _vm._v(")"),
                ],
                1
              ),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.buttonTitle,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "buttonTitle")
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("URL кнопки")]),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  disabled: _vm.isLoading,
                  loading: _vm.isLoading,
                  value: _vm.listItem.data.buttonLink,
                },
                on: {
                  input: function ($event) {
                    return _vm.mixChangeListItemHandler($event, "buttonLink")
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }